import { defineMessages } from "react-intl";

export const userProfileMessages = defineMessages({
    userProfileModalTitle: {
        id: 'USER_PROFILE_MODAL_TITLE',
        defaultMessage: 'Můj profil',
    },
});